<template>
  <div>
    <div id="person-assets">
      <div class="top">
        <img
          class="returns"
          src="@/assets/img/backleftarrow.png"
          alt=""
          @click="back()"
        />
        <span>持仓收益</span>
      </div>

      <div class="mid">
        <!-- 资产概览标题 -->
        <div class="section-title">资产概览</div>

        <!-- 总资产 -->
        <div class="total-assets">
          <div class="assets-label">总资产</div>
          <div class="assets-value">
            {{ formatNumber(positionInfo.totalBalance) }}
            <span
              class="assets-change"
              v-if="formatNumber(positionInfo.totalBalance) !== '0'"
              :class="{
                positive: positionInfo.todayFloatPL > 0,
                negative: positionInfo.todayFloatPL < 0,
                zero: positionInfo.todayFloatPL === 0,
              }"
            >
              {{ formatPL(positionInfo.todayFloatPL) }} ({{
                formatPercent(positionInfo.todayFloatRate)
              }})
            </span>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">可用资金</div>
              <div class="stat-value">
                {{ formatCurrency(positionInfo.cashBalance) }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">持仓市值</div>
              <div class="stat-value">
                {{ formatNumber(positionInfo.positionBalance) }}
              </div>
            </div>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">持仓浮动盈亏</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.totalFloatPL > 0,
                  negative: positionInfo.totalFloatPL < 0,
                  zero: positionInfo.totalFloatPL === 0,
                }"
              >
                {{ formatPL(positionInfo.totalFloatPL) }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">今日浮动盈亏</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.todayFloatPL > 0,
                  negative: positionInfo.todayFloatPL < 0,
                  zero: positionInfo.todayFloatPL === 0,
                }"
              >
                {{ formatPL(positionInfo.todayFloatPL) }}
              </div>
            </div>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">累计收益</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.cumulativeProfit > 0,
                  negative: positionInfo.cumulativeProfit < 0,
                  zero: positionInfo.cumulativeProfit === 0,
                }"
              >
                {{ formatCulReturn(positionInfo.cumulativeProfit) }}
              </div>
            </div>
            <div class="stat-item">
              <div class="stat-label">累计盈亏</div>
              <div
                class="stat-value"
                :class="{
                  positive: positionInfo.cumulativePnl > 0,
                  negative: positionInfo.cumulativePnl < 0,
                  zero: positionInfo.cumulativePnl === 0,
                }"
              >
                {{ formatPL(positionInfo.cumulativePnl) }}
              </div>
            </div>
          </div>
          <div class="stat-row">
            <div class="stat-item">
              <div class="stat-label">运行时长</div>
              <div
                class="stat-value"
              >
                {{ positionInfo.investmentDays || 0 }}天
              </div>
            </div>
          </div>
        </div>

        <!-- 持仓明细 -->
        <div class="section-title">
          持仓明细
          <div v-if="(positionList || []).length > 0" class="ai-live-date">
            <div class="current-date">
              更新于{{ positionList[0].date.replace('T', ' ').slice(0, -9)}}
            </div>
          </div>
        </div>

        <div class="new-table" v-if="positionList.length > 0">
          <div class="stock-table">
            <!-- 表头 -->
            <van-cell-group>
              <van-cell class="table-header">
                <div class="header-row">
                  <div class="col name-col">名称/代码</div>
                  <div class="col pl-col">盈亏/收益率</div>
                  <div class="col position-col">持仓/市值</div>
                  <div class="col price-col">现价/成本</div>
                </div>
              </van-cell>
            </van-cell-group>

            <!-- 股票列表 -->
            <van-cell-group v-for="stock in positionList" :key="stock.ticker">
              <!-- 第一行：主要信息 -->
              <van-cell class="stock-row main-row">
                <div class="row-content">
                  <div class="col name-col">
                    <div class="stock-info">
                      <span class="stock-name">{{ stock.tickerName }}</span>
                      <!-- <span class="stock-code">{{ stock.ticker }}</span> -->
                    </div>
                  </div>

                  <div
                    class="col pl-col"
                    :class="{
                      positive: stock.positionPL > 0,
                      negative: stock.positionPL < 0,
                    }"
                  >
                    {{ formatNumber(stock.positionPL) }}
                  </div>

                  <div class="col position-col">
                    {{ stock.shares }}
                  </div>

                  <div
                    class="col price-col"
                    :class="{
                      positive: stock.nowPrice > stock.costPrice,
                      negative: stock.nowPrice < stock.costPrice,
                    }"
                  >
                    {{ formatPrice(stock.nowPrice) }}
                  </div>
                </div>
              </van-cell>

              <!-- 第二行：次要信息 -->
              <van-cell class="stock-row sub-row">
                <div class="row-content">
                  <div class="col name-col">
                    <!-- {{ formatNumber(stock.marketValue) }} -->
                    {{ stock.ticker }}
                  </div>

                  <div
                    class="col pl-col"
                    :class="{
                      positive: stock.returnRate > 0,
                      negative: stock.returnRate < 0,
                    }"
                  >
                    {{ formatPercentage(stock.returnRate) }}
                  </div>

                  <div class="col position-col">
                    {{ formatNumber(stock.marketValue) }}
                  </div>

                  <div class="col price-col">
                    {{ formatPrice(stock.costPrice) }}
                  </div>
                </div>
              </van-cell>
            </van-cell-group>
          </div>
        </div>
        <div class="empty-data" v-else>
          <empty image="error" description="暂无持仓" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchUserReturnInfo } from "@/api/theApi";
import { Empty, CellGroup, Cell } from "vant";

export default {
  name: "StrategyAnalytics",
  components: {
    Empty,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
  },
  data() {
    return {
      positionInfo: {
        totalBalance: 0,
        cashBalance: 0,
        positionBalance: 0,
        totalFloatPL: 0,
        todayFloatPL: 0,
        todayFloatRate: 0,
        // 累计收益
        cumulativeProfit: 0,
        // 累计盈亏
        cumulativePnl: 0,
        // 运行时长
        investmentDays: 0,
      },
      positionList: [],
    };
  },
  async created() {
    await this.initData();
    this.setRefreshTimer();
  },
  mounted() {},
  updated() {},
  beforeDestroy() {
    this.clearRefreshTimer();
  },
  methods: {
    // 设置定时器
    setRefreshTimer() {
      this.refreshTimer = setInterval(() => {
        this.initData();
      }, 30000);
    },

    // 清除定时器
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer);
        this.refreshTimer = null;
      }
    },
    back() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.replace("/user");
      }
    },
    // 格式化价格（保留3位小数）
    formatPrice(value) {
      return (value || 0).toFixed(3);
    },

    // 格式化百分比
    formatPercentage(value) {
      return (value > 0 ? "+" : "") + (value * 100).toFixed(2) + "%";
    },
    isPositivePercent(percentStr) {
      if (!percentStr) return false;
      const numValue = parseFloat(percentStr.replace("%", ""));
      return !isNaN(numValue) && numValue > 0;
    },
    // 格式化数字，添加千位分隔符
    formatNumber(num) {
      if (num === null || num === undefined || isNaN(num)) return "0";
      return Number(num).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
    },
    // 格式化货币
    formatCurrency(num) {
      if (num === null || num === undefined || isNaN(num) || Number(num) === 0)
        return "0";
      return (
        "¥ " +
        Number(num).toLocaleString("zh-CN", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
      );
    },
    // 格式化百分比
    formatPercent(decimal) {
      if (decimal === null || decimal === undefined || isNaN(decimal) || Number(decimal) === 0)
        return "0";
      const percent = decimal.toFixed(2);
      return `${decimal > 0 ? "+" : ""}${percent}${
        percent === "0" || percent === "0.00" ? "" : "%"
      }`;
    },
    // 格式化盈亏金额
    formatPL(amount) {
      if (amount === null || amount === undefined || isNaN(amount)) return "0";
      const formatted = Number(amount).toLocaleString("zh-CN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      });
      return `${amount > 0 ? "+" : ""}${formatted}`;
    },
    // 格式化累计收益率
    formatCulReturn(decimal) {
      if (decimal === null || decimal === undefined || isNaN(decimal) || decimal === 0)
        return "0";
      const percent = (decimal * 100).toFixed(2);
      return `${decimal > 0 ? "+" : ""}${percent}${
        percent === "0" || percent === "0.00" ? "" : "%"
      }`;
    },
    async initData() {
      let res = await fetchUserReturnInfo();
      const { data } = res || {};
      this.positionInfo = (data && data.positionInfo) || {};
      this.positionList = (data && data.positionList) || [];
    },
  },
};
</script>

<style lang="less" scoped>
@positive-color: #ee0a24;
@negative-color: #067138;

.stock-table {
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;

  .van-cell-group {
    margin-bottom: 8px;
    overflow: hidden;

    &:first-child {
      margin-bottom: 0;
    }
  }
  .van-cell::after,
  .van-hairline--top-bottom::after,
  .van-hairline-unset--top-bottom::after {
    border: none !important;
  }

  .table-header {
    padding: 0;
    .header-row {
      padding-bottom: 6px;
      display: flex;
      width: 100%;
      border-bottom: 1px solid #0000001a;
      margin-bottom: 6px;

      .col {
        flex: 1;
        // text-align: right;
        text-align: left;
        color: #00000099;
        font-size: 12px;

        &.name-col {
          flex: 1.2;
          text-align: left;
        }

        &.pl-col {
          flex: 1.2;
        }
      }
    }
  }

  .stock-row {
    padding: 0px !important;

    &.main-row {
      font-size: 12px;
      line-height: 28px;

      .row-content {
        align-items: center;
      }
    }

    &.sub-row {
      font-size: 12px;
      line-height: 12px;
    }

    .row-content {
      display: flex;
      width: 100%;

      .col {
        flex: 1;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        &.name-col {
          color: #000;
          flex: 1.2;
          text-align: left;
          justify-content: flex-start;
        }

        &.pl-col {
          flex: 1.2;
          text-align: left;
          justify-content: flex-start;
          &.positive {
            color: @positive-color;
          }

          &.negative {
            color: @negative-color;
          }
        }

        &.position-col,
        &.price-col {
          color: #000;
          text-align: left;
          justify-content: flex-start;
        }
        &.price-col.positive {
          color: @positive-color;
        }
        &.price-col.negative {
          color: @negative-color;
        }

        .stock-info {
          .stock-name {
            font-size: 12px;
            color: #000000;
          }

          .stock-code {
            font-size: 11px;
            color: #00000080;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

#person-assets {
  height: 100vh;
  background: #f8f8f8;
  .ai-live-date {
    position: absolute;
    right: 1px;
    bottom: 3px;
    .current-date {
      font-size: 14px;
      color: #8e8e93;
    }
  }

  .top {
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    & > span {
      font-size: 16px;
      font-weight: 600;
    }

    .returns {
      position: absolute;
      width: 24px;
      left: 16px;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
    line-height: 1.5;
    color: #000;
    position: relative;
  }

  .mid {
    padding: 0 16px 16px;

    &.fixed-height {
      height: calc(100vh - 108px);
    }
  }

  .total-assets {
    background: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    margin-bottom: 32px;
  }

  .assets-label {
    font-size: 13px;
    color: #8e8e93;
    line-height: 1.5;
  }

  .assets-value {
    font-size: 28px;
    font-weight: 700;
    color: #000;
    line-height: 1.5;
  }

  .assets-change {
    font-size: 12px;
    line-height: 1.5;
    margin-left: 4px;
    color: #8e8e93;

    &.positive {
      color: #d70000;
    }

    &.negative {
      color: #48bb78;
    }

    &.zero {
      color: #8e8e93;
    }
  }

  .stat-row {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    &:last-child {
      margin-bottom: 0;
      margin-top: 8px;
    }
  }

  .stat-item {
    flex: 1 0 0;
    width: 50%;
  }

  .stat-label {
    font-size: 13px;
    line-height: 1.5;
    color: #8e8e93;
  }

  .stat-value {
    font-size: 14px;
    line-height: 1.5;
    font-weight: 500;
    color: #000;

    &.positive {
      color: #d70000;
    }

    &.negative {
      color: #48bb78;
    }
  }

  .empty-data {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 200px;
    background-color: #fff;
    margin: 12px 0;
    padding: 16px;
    border-radius: 8px;
  }
}
</style>
